"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "delay", {
  enumerable: true,
  get: function get() {
    return _reduxSaga.delay;
  }
});
exports.safeSaga = exports.consoleErrorRecovery = exports.isolateSelectorsState = exports.createSnakeKeys = exports.createCamelKeys = exports.hasLodashPrefix = exports.hasDashes = exports.isPlainObject = exports.isObject = exports.alwaysNull = exports.alwaysFn = exports.RdxModResourceError = exports.RdxModEntitiesError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _makeErrorCause = require("make-error-cause");

var _effects = require("redux-saga/effects");

var _humps = require("humps");

var _reduxSaga = require("redux-saga");

// --
// -- Async Helpers
// --
// --
// -- Custom Errors
// --
class RdxModEntitiesError extends _makeErrorCause.BaseError {}

exports.RdxModEntitiesError = RdxModEntitiesError;

class RdxModResourceError extends _makeErrorCause.BaseError {} // --
// -- General Utils
// --


exports.RdxModResourceError = RdxModResourceError;

var alwaysFn = function (val) {
  return function () {
    return val;
  };
};

exports.alwaysFn = alwaysFn;
var alwaysNull = alwaysFn(null);
exports.alwaysNull = alwaysNull;

var isObject = function (input) {
  return typeof input === 'object';
};

exports.isObject = isObject;

var isPlainObject = function (val) {
  return !!val && typeof val === 'object' && val.constructor === Object;
}; // --
// -- object key formating
// --


exports.isPlainObject = isPlainObject;

var hasDashes = function (str) {
  return str.includes('-');
};

exports.hasDashes = hasDashes;

var hasLodashPrefix = function (str) {
  return str.startsWith('_');
};

exports.hasLodashPrefix = hasLodashPrefix;

var createCamelKeys = function (customPred) {
  if (customPred === void 0) {
    customPred = alwaysNull;
  }

  return function (obj) {
    return (// eslint-disable-next-line complexity
      (0, _humps.camelizeKeys)(obj, function (key, convert) {
        var isSafe = !hasDashes(key) && !hasLodashPrefix(key);
        var pred = customPred(key, obj, isSafe); // Custom Key (the pred value) when pred is `string`

        if (typeof pred === 'string') return pred; // Original Key when pred is `false`

        if (pred === false) return key; // Converted Key when pred is `true`

        if (pred === true || isSafe) return convert(key); // Otherwise use original key

        return key;
      })
    );
  };
};

exports.createCamelKeys = createCamelKeys;

var createSnakeKeys = function (customPred) {
  if (customPred === void 0) {
    customPred = alwaysNull;
  }

  return function (obj) {
    return (// eslint-disable-next-line complexity
      (0, _humps.decamelizeKeys)(obj, function (key, convert, options) {
        var isSafe = !hasDashes(key) && !hasLodashPrefix(key);
        var pred = customPred(key, obj, isSafe); // Custom Key (the pred value) when pred is `string`

        if (typeof pred === 'string') return pred; // Original Key when pred is `false`

        if (pred === false) return key; // Converted Key when pred is `true`

        if (pred === true || isSafe) return convert(key, options); // Otherwise use original key

        return key;
      })
    );
  };
}; // --
// -- Selector State Helpers
// --


exports.createSnakeKeys = createSnakeKeys;

var isolateSelectorsState = function (storeName, selectors) {
  var getState = function (state) {
    if (state === void 0) {
      state = {};
    }

    return state[storeName] || {};
  };

  var isolatedSelectors = {};
  Object.keys(selectors).forEach(function (name) {
    var selector = selectors[name];

    if (typeof selector === 'function') {
      isolatedSelectors[name] = function (state) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return selector(getState(state), ...args);
      };
    } else {
      isolatedSelectors[name] = selector;
    }
  });
  return isolatedSelectors;
}; // --
// -- redux-saga helpers
// --


exports.isolateSelectorsState = isolateSelectorsState;

var consoleErrorRecovery = function (err) {
  /* eslint-disable no-console */
  console.error('caught', err);

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  console.log({
    err,
    args
  });
  /* eslint-enable no-console */
};

exports.consoleErrorRecovery = consoleErrorRecovery;

var safeSaga = function (recovery) {
  return function (saga) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line func-names
      _regenerator.default.mark(function _callee(action) {
        return _regenerator.default.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _effects.call)(saga, ...args, action);

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                _context.next = 9;
                return (0, _effects.call)(recovery, _context.t0, ...args);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      })
    );
  };
};

exports.safeSaga = safeSaga;